<template>
  <b-modal
    id="modal-user-conf-tracking"
    ref="bModal"
    centered
    :title="$t('userConfiguration.printerConf')"
    modal-class="confModalTracking"
  >
    <b-row>
      <b-col>
        <user-configuration-print-tab ref="printsUserConf" />
      </b-col>
    </b-row>
    <div
      slot="modal-footer"
      class="footer-banner w-100"
    >
      <div class="row">
        <b-col>
          <div class="d-flex justify-content-between px-2">
            <div>
              <b-button
                variant="outline-secondary"
                data-dismiss="modal"
                @click="hide"
              >
                {{ $t('global.cancel') }}
              </b-button>
            </div>
            <div>
              <b-button
                class="btn--primary d-flex align-items-center"
                @click="savePrinters"
              >
                <i
                  class="far fa-save mr-2"
                  aria-hidden="true"
                />
                {{ $t('global.save') }}
              </b-button>
            </div>
          </div>
        </b-col>
      </div>
    </div>
  </b-modal>
</template>

<script>
import UserConfigurationPrintTab from '@/components/userConfiguration/print/tab/user-configuration-print-tab.vue'

export default {
    name: 'ModalUserConfTracking',
    components: {
        UserConfigurationPrintTab
    },
    methods: {
        async savePrinters() {
            await this.$refs.printsUserConf.savePrinters()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        show() {
            this.tabIndex = this.tabPosition
            this.$refs.bModal.show()
        }
    }
}
</script>

<style lang="scss">

    .confModalTracking .modal-body {
        height: 550px !important;
        overflow-y: auto;
    }

    .confModalTracking .title {
        color: vt-color(primary) !important;
    }

    .confModalTracking .subtitle {
        color: vt-color(dark-text) !important;
    }

    .confModalTracking .printer-row {
        border-bottom: 1px solid rgba(0, 0, 0, .125);
        padding: 7px;
    }

</style>
